import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { microAppInitialized } from '@mynexus/mfe-core';

@Component({
    selector: 'app-document',
    templateUrl: './mnc-document.component.html',
    styleUrls: ['./mnc-document.component.scss'],
    standalone: false
})
export class MncDocumentComponent implements AfterViewInit {

  constructor(
    private ref: ElementRef,
    private router: Router
  ) {
    // this is required to trigger the router for the micro app on initial load.
    this.router.initialNavigation();
  }

  @Input() set url(value: string){
    this.router.navigate([value]);
  }

  ngAfterViewInit(): void {
    microAppInitialized(this.ref, this.router, 'Document')
  }
}
